import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const getStatusColor = (status: string) => {
  switch (status) {
    case "active": return "bg-green-100 text-green-800 border-green-200";
    case "inactive": return "bg-red-100 text-red-800 border-red-200";
    case "new": return "bg-blue-100 text-blue-800 border-blue-200";
    case "sent": return "bg-blue-100 text-blue-800 border-blue-200";
    case "accepted": return "bg-green-100 text-green-800 border-green-200";
    case "rejected": return "bg-red-100 text-red-800 border-red-200";
    case "under_review": return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "completed": return "bg-blue-100 text-blue-800 border-blue-200";
    case "on_hold": return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "cancelled": return "bg-red-100 text-red-800 border-red-200";
    case "pipeline": return "bg-purple-100 text-purple-800 border-purple-200";
    default: return "bg-gray-100 text-gray-800 border-gray-200";
  }
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge className={cn(getStatusColor(status), className)}>
      {status}
    </Badge>
  );
}